import {
  SizeGuideSection 
} from "../size-guide-section"

const waderTableData = {
  headers: [
    [
      {
        content: "Neoprene Waders",
        colSpan: 6,
      },
    ],
    [
      {
        content: "Wader Size",
      },
      {
        content: "Shoes Size",
      },
      {
        content: "Total Length(In)",
      },
      {
        content: "Inseam(In)",
      },
      {
        content: "Chest(In)",
      },
      {
        content: "Hip(In)",
      },
    ],
  ],
  data: [
    [
      {
        content: "5" 
      },
      {
        content: "5" 
      },
      {
        content: "49.8" 
      },
      {
        content: "33" 
      },
      {
        content: "41.7" 
      },
      {
        content: "40.7" 
      },
    ],
    [
      {
        content: "6" 
      },
      {
        content: "6" 
      },
      {
        content: "51" 
      },
      {
        content: "33.9" 
      },
      {
        content: "42.7" 
      },
      {
        content: "41.7" 
      },
    ],
    [
      {
        content: "7" 
      },
      {
        content: "7" 
      },
      {
        content: "51.2" 
      },
      {
        content: "34.1" 
      },
      {
        content: "43.5" 
      },
      {
        content: "42.5" 
      },
    ],
    [
      {
        content: "8" 
      },
      {
        content: "8" 
      },
      {
        content: "54.4" 
      },
      {
        content: "37" 
      },
      {
        content: "44.7" 
      },
      {
        content: "45.7" 
      },
    ],
    [
      {
        content: "9" 
      },
      {
        content: "9" 
      },
      {
        content: "54.4" 
      },
      {
        content: "37" 
      },
      {
        content: "47.5" 
      },
      {
        content: "46.5" 
      },
    ],
    [
      {
        content: "10" 
      },
      {
        content: "10" 
      },
      {
        content: "55.3" 
      },
      {
        content: "37.6" 
      },
      {
        content: "49.2" 
      },
      {
        content: "48" 
      },
    ],
    [
      {
        content: "11" 
      },
      {
        content: "11" 
      },
      {
        content: "56.9" 
      },
      {
        content: "38.6" 
      },
      {
        content: "50.4" 
      },
      {
        content: "49.2" 
      },
    ],
    [
      {
        content: "12" 
      },
      {
        content: "12" 
      },
      {
        content: "57.7" 
      },
      {
        content: "39.2" 
      },
      {
        content: "51.9" 
      },
      {
        content: "50.4" 
      },
    ],
    [
      {
        content: "13" 
      },
      {
        content: "13" 
      },
      {
        content: "59.9" 
      },
      {
        content: "40.6" 
      },
      {
        content: "53.1" 
      },
      {
        content: "51.6" 
      },
    ],
    [
      {
        content: "14" 
      },
      {
        content: "14" 
      },
      {
        content: "61.4" 
      },
      {
        content: "41.4" 
      },
      {
        content: "54.2" 
      },
      {
        content: "52.8" 
      },
    ],
  ],
}

export const Wader = ({
  className
}: {
  className?: string
}) => {
  return <SizeGuideSection 
    title='Neoprene Waders'
    tableData={waderTableData}
    className={className}
  />
}
